<template>
  <div>{{txt}}</div>
</template>
<script>
  export default {
    data () {
      return {
        txt: '登出中...'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/others/reload.vue